<h2 mat-dialog-title>{{ad_id? 'Update Advertise' : 'Add Advertise'}}</h2>

<form [formGroup]="addAdForm" (ngSubmit)="onFormSubmit()">
    <div mat-dialog-content class="content">


        <div class="col-md-6">
            <div class="adsimage">
                <img src="https://aieventzo.com/upload/advertise/{{this.imagePath}}"
                    style="max-width: 500px;max-height: 500px;">
            </div>
            <mat-label>Event Image*</mat-label>
            <div class="input-group mb-3">
                <input type="file" class="form-control" id="inputGroupFile01" #file accept='image/*'
                    id="exampleInputFile" (change)="previewpimage(file.files)" required="true">
            </div>
        </div>

        <div class="column">

            <mat-form-field appearance="outline">
                <mat-label>Link</mat-label>
                <input [ngModel]="link" formControlName="link" matInput placeholder="Enter Your Link">

            </mat-form-field>
        </div>

        <div mat-dialog-actions class="action" align="end">
            <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
            <button mat-raised-button type="submit" color="primary">{{ad_id? 'Update' : 'Add'}}</button>
        </div>
    </div>
</form>